








































import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import { InvestmentEntity } from 'types/investment-entity';
import { user } from '@store/modules/user';

@Component
export default class NavInvestmentEntityList extends Vue {
	appBasePath = process.env.VUE_APP_BASE_PATH;

	displayAccountType(entity: InvestmentEntity): string {
		if (entity.isIraEntity) {
			if (entity.iraEntityMetadata.iraTypeLabel) {
				return entity.iraEntityMetadata.iraTypeLabel + ' IRA';
			}
			return 'Undesignated IRA';
		}
		return entity.entityTypeLabel ?? '';
	}

	get investmentEntities(): Array<InvestmentEntity> {
		if (user.user) {
			return user.user.entityDetails.investmentEntities;
		}

		return [];
	}

	get isDesktop(): boolean {
		return app.screenSize === 'DESKTOP';
	}
}
